module.exports = __webpack_public_path__ + "img/loading2.3c1c8d5d.png";